<p-dropdown [options]="filterOptions"
    dropdownIcon="ui-icon-arrow-drop-down"
    (onChange)="clickEvent($event.value)"
    [style]="{'width': defaultWidth }"
    [(ngModel)]="selectedOption"
    optionLabel="label">

    <ng-template let-selectedItem pTemplate="selectedItem">
        <i *ngIf="selectedItem.value.icon !== ''|| undefined" [class]="selectedItem.value.icon"></i>
        <span style="padding-left:10px">{{selectedItem.label}}</span>
    </ng-template>

    <ng-template let-item pTemplate="item">
        <i *ngIf="item.value.icon !== ''|| undefined" [class]="item.value.icon"></i>
        <span style="padding-left:10px">{{item.label}}</span><span *ngIf="item.value.subtext" class="item-subtext"> - {{item.value.subtext}}</span>
    </ng-template>

</p-dropdown>

